export default __webpack_public_path__ + "static/media/SetYourselfUpforSuccess.cc717894.jpg";